import gql from 'graphql-tag';

export default gql`
  {
    getQuestions {
      id
      order
      detail {
        question
        response
      }
    }
  }
`;
